export const callMixin = {

    //********************* START CALL ********************************//
    // "Call" button in the dm header - bubbles up to gudhub-messenger, which
    // opens the Phone tab's call profile for this DM (see gh_conversation.js'
    // open_call_profile listener). Calls are placed from that screen only.
    startCall() {
        if(!this.dmState?.otherUserId) return;

        this.dispatchEvent(new CustomEvent('open_call_profile', {
            bubbles: true,
            composed: true,
        }));
    },
};
